import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireJs } from '../node_modules/react-input-range/lib/js/index.js';

var jsExports = requireJs();
var InputRange = /*@__PURE__*/getDefaultExportFromCjs(jsExports);

export { InputRange as default };
